import PolygonLookup from 'polygon-lookup';

import kebabCase from 'lodash/kebabCase';
import randomColor from 'randomcolor';
import sortedUniqBy from 'lodash/sortedUniqBy';
import uniqBy from 'lodash/uniqBy';
import unionBy from 'lodash/unionBy';
import sortBy from 'lodash/sortBy';

const defaultPreferences = {
  useCategory: {},
  scale: {},
  usePattern: {},
  businessType: {},
  businessSpeed: {},
  capacity: {},
  county: {},
  locations: [],
  coordinates: null,
};

export default {

  state: {
    preferences: defaultPreferences,
  },

  getters: {

    usersLabel(state) {
      switch (state.preferences.businessType.value) {
        case 'barrestaurant':
          return 'seat(s)';
        case 'coffeeshop':
          return 'seat(s)';
        case 'officeretail':
          return 'workspace(s)';
        case 'lodging':
          return 'bed(s)';
        default:
          return 'user(s)';
      }
    },

    coordinatesFormatted(state) {
      const coordinates = state.preferences.coordinates;
      if (coordinates && coordinates.lat && coordinates.lng) {
        return `${coordinates.lat.toFixed(5)}, ${coordinates.lng.toFixed(5)}`;
      }
      return null;
    },

    scale(state) {
      return state.preferences.scale.number;
    },

    usePattern(state) {
      return state.preferences.usePattern.text;
    },

    businessSpeed(state) {
      return state.preferences.businessSpeed.text;
    },

    capacity(state) {
      if (state.preferences.useCategory.text === 'Residential') {
        return state.preferences.scale.number;
      } else {
        return state.preferences.capacity.number || 1;
      }
    },

    recommendedPerUser(state) {
      if (state.preferences.useCategory.text === 'Residential') {
        return state.preferences.usePattern.number;
      } else {
        const businessSpeed = state.preferences.businessSpeed;
        const businessType = state.preferences.businessType;
        if (businessType.value && businessSpeed.number) {
          // console.log(businessType);
          // console.log(businessSpeed);
          return businessSpeed.number[businessType.value];
        } else {
          return 5;
        }
      }
    },

    filteredServiceAreas(state, getters, rootState) {
      console.group('wizard filtering');
      let data = rootState.data.serviceAreas;

      console.log(`Initial length: ${data.length}`);

      if (state.preferences.county.text === 'Mono' || state.preferences.county.text === 'Inyo') {
        data = data.filter(i => i.properties.County === state.preferences.county.text || !i.properties.County);
      }

      console.log(`After county length: ${data.length}`);

      if (state.preferences.locations.length) {
        const filterFunction = (item) => {
          const regional = item.properties.Location === 'Regional Service';

          const d395 = item.properties.Location === 'Along Digital 395 Route';

          const locValue = state.preferences.locations.map(i => i.text).includes(item.properties.Location);
          return locValue || regional || d395;

        };
        data = data.filter(filterFunction);
      }

      console.log(`After locations length: ${data.length}`);

      if (state.preferences.coordinates && state.preferences.coordinates && rootState.data.serviceAreas.length) {
        const lookup = new PolygonLookup({
          type: 'FeatureCollection',
          features: rootState.data.serviceAreas,
        });

        const featColl = lookup.search(state.preferences.coordinates.lng, state.preferences.coordinates.lat, -1);

        if (state.preferences.locations.length) {
          data = data.concat(featColl.features);
        } else {
          data = featColl.features;
          // data = unionBy(data, featColl.features);
        }
      }

      console.log(`After coordinates length: ${data.length}`);

      console.groupEnd();

      return uniqBy(data, 'properties.OBJECTID');
    },

    allLocations(state, getters, rootState) {
      const blacklist = [
        'Along Digital 395 Route',
        'Regional Service',
      ];

      const features = rootState.data.serviceAreas.filter(i => !blacklist.includes(i.properties.Location));

      const amendedLocs = features.map(item => {
        const text = item.properties.Location || 'None';
        return {
          county: item.properties.County,
          value: kebabCase(text),
          text,
          class: '',
          style: {
            backgroundColor: randomColor({
              hue: 'orange', // red, orange, yellow, green, blue, purple, pink and monochrome
              luminosity: 'bright', // bright, light or dark
              seed: text,
            })
          },
          mdIcon: 'location_city',
        };
      });

      const sorted = sortedUniqBy(sortBy(amendedLocs, 'text'), 'text');

      return sorted;
    },

    locationsFiltered(state, getters, rootState) {
      const blacklist = [
        'Along Digital 395 Route',
        'Regional Service',
      ];

      const features = rootState.data.serviceAreas.filter(i => !blacklist.includes(i.properties.Location));

      const amendedLocs = features.map(item => {
        const text = item.properties.Location || 'None';
        return {
          county: item.properties.County,
          value: kebabCase(text),
          text,
          class: '',
          style: {
            backgroundColor: randomColor({
              hue: 'orange', // red, orange, yellow, green, blue, purple, pink and monochrome
              luminosity: 'bright', // bright, light or dark
              seed: text,
            })
          },
          mdIcon: 'location_city',
        };
      });

      const sorted = sortedUniqBy(sortBy(amendedLocs, 'text'), 'text');

      // const index = sorted.findIndex(i => i.value === 'none');
      // const none = sorted.splice(index, 1);
      // sorted.unshift(none[0]);
      // sorted.shift();

      if (rootState.wizard.preferences.county.value && rootState.wizard.preferences.county.value !== 'both') {
        return sorted.filter(i => i.county === rootState.wizard.preferences.county.text);
      }

      return sorted;
    },

    speedPreference(state, getters) {
      let speed = 0;
      if (state.preferences.useCategory && state.preferences.useCategory.value === 'business') {
        if (state.preferences.businessSpeed.value && getters.capacity) {
          const speedRating = state.preferences.businessSpeed.number[state.preferences.businessType.value];
          speed = speedRating * getters.capacity;
        }
      } else {
        if (state.preferences.scale.value && state.preferences.usePattern.value) {
          // const scale = models.scale.find(item => item.value === state.preferences.scale.value);
          // const usePattern = models.usePattern.find(item => item.value === state.preferences.usePattern.value);
          speed = state.preferences.scale.number * state.preferences.usePattern.number;
        }
      }
      return speed;
    },

  },

  mutations: {

    SET_PREFERENCES(state, payload) {
      state.preferences = payload;
    },

    SET_SELECTIONS(state, payload) {
      state.selections = payload;
    },

    CLEAR_PREFERENCE_BY_KEY(state, payload) {
      state.preferences[payload.key] = null;
    },

  },

  actions: {

    clearPreferencesByKey({ commit }, key) {
      commit('CLEAR_PREFERENCE_BY_KEY', { key });
    },

    resetPreferences({ commit }) {
      commit('SET_PREFERENCES', defaultPreferences);
      commit('SET_SPEED_LOW', null);
      commit('SET_SPEED_HIGH', null);
      commit('SET_COUNTY', null);
      commit('SET_LOCATIONS', []);
    },

    setPreferences({ state, commit, getters }, value) {
      const temp = { ...state.preferences, ...value };
      commit('SET_PREFERENCES', temp);
      commit('SET_SPEED_LOW', getters.speedPreference);
      commit('SET_COUNTY', temp.county.text);
      if (temp.locations) {
        commit('SET_LOCATIONS', uniqBy(temp.locations.map(loc => loc.text)));
      } else {
        commit('SET_LOCATIONS', []);
      }
    },

    setSelection({ commit, state }, selection) {
      const newSelections = {
        ...state.selections,
      };
      newSelections[selection.key] = selection.value;
      commit('SET_SELECTIONS', newSelections);
    },

    setWizardLocations({ dispatch }, { value }) {
      dispatch('setSelection', {
        key: 'locations',
        value: value,
      });
    },

  },

};
